import React, { useState } from "react";
import {
  TableCell,
  TableRow,
  Box,
  Typography,
  Modal,
  Tooltip,
} from "@mui/material";
import VRSessionModal from "../VRSessionModal/VRSessionModal";
import useStyles from "./ReviewsList.styles";
import moment from "moment";
import UserAvatar from "../../Utilities/UserAvatar/UserAvatar.component";
import UsersViewer from "../../Utilities/UsersViewer/UsersViewer";

const VRSessionList = ({ session }) => {
  const classes = useStyles();
  const [openVRSessionViewerModal, setOpenVRSessionViewerModal] =
    useState(false);

  const handleOpenVRSessionViewerModal = () => {
    setOpenVRSessionViewerModal(!openVRSessionViewerModal);
  };

  function formatSecondsToHHMMSS(seconds) {
    const roundedSeconds = Math.round(seconds);

    return moment
      .utc(roundedSeconds * 1000)
      .format("HH:mm:ss");
  }

  return (
    <TableRow
      key={session.id}
      onClick={handleOpenVRSessionViewerModal}
      style={{ cursor: "pointer" }}
      hover
    >
      <TableCell
        align="left"
        style={{ borderBottom: "1px solid #252A38", padding: "15px" }}
      >
        {session.name}
      </TableCell>
      <TableCell
        align="center"
        style={{ borderBottom: "1px solid #252A38", padding: "15px" }}
      >
        {moment(session.created_at).format("DD-MM-YYYY")}<br />
        <span style={{ color: "#B1B5C9" }}>{moment(session.created_at).format("hh:mm:ss A")}</span>
      </TableCell>
      <TableCell
        align="center"
        style={{ borderBottom: "1px solid #252A38", padding: "15px" }}
      >
        {session.session_trackable_count}
      </TableCell>
      <TableCell
        align="center"
        style={{ borderBottom: "1px solid #252A38", padding: "15px" }}
      >
        {session.duration ? formatSecondsToHHMMSS(session.duration) : "--"}
      </TableCell>
      <TableCell
        align="center"
        style={{ borderBottom: "1px solid #252A38", padding: "15px" }}
      >
        <div
          style={{
            border: `2px solid #606479`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "5px",
            borderRadius: "25px",
            padding: "1px 7px 1px 0px",
            width: "max-content",
            margin: "0 auto",
          }}
        >
          <UserAvatar
            avatar={session?.created_by?.avatar}
            firstName={session?.created_by?.first_name}
            lastName={session?.created_by?.last_name}
          />
          <span>
            {session?.created_by?.first_name} {session?.created_by?.last_name}
          </span>
        </div>
      </TableCell>

      <TableCell
        align="center"
        style={{ borderBottom: "1px solid #252A38", padding: "15px" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <UsersViewer editable="no" assignedUser={session?.participants} />
        </div>
      </TableCell>
      <TableCell
        align="right"
        style={{
          whiteSpace: "nowrap",
          color: "#B1B5C9",
          borderBottom: "1px solid #252A38",
          padding: "15px",
        }}
      >
        {session.transcription_status === "completed"
          ? "Completed"
          : session.transcription_status == "in_progress" ? "Processing" : "Not Started"}
      </TableCell>
      <Modal
        className={classes.reviewPageModals}
        open={openVRSessionViewerModal}
        onClose={(event, reason) => {
          // Only close on escape key press, not on backdrop click
          if (reason === "escapeKeyDown") {
            handleOpenVRSessionViewerModal();
          }
        }}
      >
        <Box
          onClick={(e) => {
            // Stop event propagation to prevent modal from closing when clicking inside
            e.stopPropagation();
          }}
        >
          <VRSessionModal
            closeModal={handleOpenVRSessionViewerModal}
            session={session}
          />
        </Box>
      </Modal>
    </TableRow>
  );
};

export default VRSessionList;
